import { ApolloError, useQuery } from '@apollo/client';
import { useState } from 'react';
import { SURVEY_LIST } from '../services/ApolloClient/Queries';
import { ISurveys, SURVEY_TYPES } from '../types/surveys';

export const useSurveyData = (surveyType: SURVEY_TYPES, version?: number) => {
  const [loader, setLoader] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const [surveyData, setSurveyData] = useState<ISurveys | null>(null);

  useQuery(SURVEY_LIST, {
    variables: { type: surveyType, version },
    fetchPolicy: 'no-cache',
    onCompleted: (data: { surveys: ISurveys }) => {
      setSurveyData(data?.surveys || null);
      setLoader(false);
    },
    onError: (err: ApolloError) => setError(err.message),
  });

  return { loader, error, surveyData };
};
